import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import { Advertiser, Program, Location } from '@/models/index'

@Model()
export default class Customer extends ApplicationRecord {
  static jsonapiType = 'customers'

  @Attr() id!: string
  @Attr() createdAt!: string
  @Attr() updatedAt!: string
  @Attr() email!: string
  @Attr() businessEmail!: string
  @Attr() unconfirmedEmail!: string
  @Attr() firstname!: string
  @Attr() lastname!: string
  @Attr() phoneNumber!: string
  @Attr() password!: string
  @Attr() passwordConfirmation!: string
  @Attr() confirmedAt!: string | null
  @Attr() isConfirmed!: boolean
  @Attr() subdomain!: string
  @Attr() cniegCode!: null | string
  @Attr() isRetired!: boolean
  @Attr() optinNewsletter!: boolean
  @Attr() registrationStatus!: string
  @Attr() registrationFailureReason!: string
  @Attr() locked!: boolean
  @Attr() trusted!: boolean
  @Attr() hasNativeSignIn?: boolean
  @Attr() lastNativeSignInAt?: string | null
  @Attr() programId!: string

  @BelongsTo() advertiser!: Advertiser
  @BelongsTo() program!: Program
  @BelongsTo() location!: Location

  public getColorByName() {
    let name = ''
    let hash = 0

    if (this.firstname && this.lastname) name = this.firstname + this.lastname

    if (name.length === 0) return hash

    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash)
      hash = hash & hash
    }
    let color = '#'
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 255
      color += ('00' + value.toString(16)).substr(-2)
    }
    return color
  }
}
